import Table from '@/components/Table/Table.jsx'
import TableChooseProduct from '../_PRODUCT/TableChooseProduct.jsx'
import {useMapContext} from '@/components/MindMap/index.mjs'

const TableChooseBf = (props) => {
    const map = useMapContext()
    const {prjTypeCode, subTypeCode} = map.data

    const columnModule = (() => {
        if (
            'BM' === prjTypeCode ||
            'BODA2' === subTypeCode
        ) {
            return {
                title: '流程模块',
                dataIndex: 'pmNamePath',
                component: <Table.ViewText />,
            }
        }
        else {
            return {
                title: '业务域',
                dataIndex: 'bmNamePath',
                component: <Table.ViewText />,
            }
        }
    })()

    const columns = [
        columnModule,

        'BCT' === map.data.prjTypeCode && {
            title: '界面方案',
            dataIndex: 'uiCase',
            component: <Table.ViewText />,
        },

        {
            title: '流程代码',
            dataIndex: 'bfNo',
            component: <Table.ViewText />,
        },

        {
            title: '流程名称',
            dataIndex: 'bfName',
            component: <Table.ViewText />,
        },
    ].filter(a => a)

    return (
        <TableChooseProduct
            columns={columns}
            {...props}
        />
    )
}

export default TableChooseBf
